import {ValidationMessage} from 'common';
import {SelectField, SelectFieldProps} from 'evergreen-ui';
import React, {memo} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {isLanguageRequired, Referral} from 'referral';
import {Observable} from 'rxjs';
import {useObservable} from 'rxsupport';
import {OfferFormInput} from './OfferForm';

type ServiceInRequiredLanguageInputProps = {
    referral: Referral;
    isSubmitting$: Observable<boolean>;
} & SelectFieldProps;
export const ServiceInRequiredLanguageInput = memo(({
                                                        referral,
                                                        isSubmitting$,
                                                        ...selectProps
                                                    }: ServiceInRequiredLanguageInputProps) => {
    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<OfferFormInput>();
    const sending = useObservable(isSubmitting$, false);

    return (
        <Controller
            name='provideServiceInRequiredLanguage'
            control={control}
            rules={{
                required: {
                    value: isLanguageRequired(referral),
                    message: 'This field is required.',
                },
            }}
            render={({field: { onChange, value }}) => {
                const props = {
                    maxWidth: '24em',
                    label: `Can your team provide services in "${referral.requiredLanguage}"?`,
                    ...selectProps,
                    onChange,
                    value: value ? value : undefined,
                    isInvalid: !!errors?.provideServiceInRequiredLanguage?.message,
                    validationMessage: <ValidationMessage error={errors?.provideServiceInRequiredLanguage}/>,
                    disabled: sending,
                };
                return (
                    <SelectField {...props}>
                        <option/>
                        <option value='true'>Yes</option>
                        <option value='false'>No, interpreter required</option>
                    </SelectField>
                );
            }}
        />
    );
});
